import _classCallCheck from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _get from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/get";
import _inherits from "C:\\Users\\User\\Desktop\\booster\\coaching\\node_modules\\@babel\\runtime/helpers/esm/inherits";

/**
 * @module ol/MapBrowserEvent
 */
import MapEvent from './MapEvent.js';
/**
 * @classdesc
 * Events emitted as map browser events are instances of this type.
 * See {@link module:ol/Map~Map} for which events trigger a map browser event.
 * @template {UIEvent} EVENT
 */

var MapBrowserEvent =
/*#__PURE__*/
function (_MapEvent) {
  _inherits(MapBrowserEvent, _MapEvent);

  /**
   * @param {string} type Event type.
   * @param {import("./Map.js").default} map Map.
   * @param {EVENT} originalEvent Original event.
   * @param {boolean} [dragging] Is the map currently being dragged?
   * @param {import("./Map.js").FrameState} [frameState] Frame state.
   * @param {Array<PointerEvent>} [activePointers] Active pointers.
   */
  function MapBrowserEvent(type, map, originalEvent, dragging, frameState, activePointers) {
    var _this;

    _classCallCheck(this, MapBrowserEvent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MapBrowserEvent).call(this, type, map, frameState));
    /**
     * The original browser event.
     * @const
     * @type {EVENT}
     * @api
     */

    _this.originalEvent = originalEvent;
    /**
     * The map pixel relative to the viewport corresponding to the original browser event.
     * @type {?import("./pixel.js").Pixel}
     */

    _this.pixel_ = null;
    /**
     * The coordinate in the user projection corresponding to the original browser event.
     * @type {?import("./coordinate.js").Coordinate}
     */

    _this.coordinate_ = null;
    /**
     * Indicates if the map is currently being dragged. Only set for
     * `POINTERDRAG` and `POINTERMOVE` events. Default is `false`.
     *
     * @type {boolean}
     * @api
     */

    _this.dragging = dragging !== undefined ? dragging : false;
    /**
     * @type {Array<PointerEvent>|undefined}
     */

    _this.activePointers = activePointers;
    return _this;
  }
  /**
   * The map pixel relative to the viewport corresponding to the original event.
   * @type {import("./pixel.js").Pixel}
   * @api
   */


  _createClass(MapBrowserEvent, [{
    key: "preventDefault",

    /**
     * Prevents the default browser action.
     * See https://developer.mozilla.org/en-US/docs/Web/API/event.preventDefault.
     * @api
     */
    value: function preventDefault() {
      _get(_getPrototypeOf(MapBrowserEvent.prototype), "preventDefault", this).call(this);

      if ('preventDefault' in this.originalEvent) {
        /** @type {UIEvent} */
        this.originalEvent.preventDefault();
      }
    }
    /**
     * Prevents further propagation of the current event.
     * See https://developer.mozilla.org/en-US/docs/Web/API/event.stopPropagation.
     * @api
     */

  }, {
    key: "stopPropagation",
    value: function stopPropagation() {
      _get(_getPrototypeOf(MapBrowserEvent.prototype), "stopPropagation", this).call(this);

      if ('stopPropagation' in this.originalEvent) {
        /** @type {UIEvent} */
        this.originalEvent.stopPropagation();
      }
    }
  }, {
    key: "pixel",
    get: function get() {
      if (!this.pixel_) {
        this.pixel_ = this.map.getEventPixel(this.originalEvent);
      }

      return this.pixel_;
    },
    set: function set(pixel) {
      this.pixel_ = pixel;
    }
    /**
     * The coordinate corresponding to the original browser event.  This will be in the user
     * projection if one is set.  Otherwise it will be in the view projection.
     * @type {import("./coordinate.js").Coordinate}
     * @api
     */

  }, {
    key: "coordinate",
    get: function get() {
      if (!this.coordinate_) {
        this.coordinate_ = this.map.getCoordinateFromPixel(this.pixel);
      }

      return this.coordinate_;
    },
    set: function set(coordinate) {
      this.coordinate_ = coordinate;
    }
  }]);

  return MapBrowserEvent;
}(MapEvent);

export default MapBrowserEvent;